import { createContext, useContext } from 'react';
import type { ThemeModeContextValue } from './types';
export const ThemeModeContext = createContext<ThemeModeContextValue | null>(null);
ThemeModeContext.displayName = 'ThemeModeContext';

/** Read and update the active light/dark mode from `AppProvider`. */
export const useThemeMode = () => {
  const value = useContext(ThemeModeContext);
  if (value == null) {
    throw new Error("useThemeMode must be used within AppProvider");
  }
  return value;
};